import React, { useEffect, useState } from "react";
import PageTitle from "../../../Components/UI/PageTitle";
import LightButton from "../../../Components/UI/LightButton";
import { useParams } from "react-router-dom";
import { transformKeys } from "../../../_helper";
import Loader from "../../../Components/Loader";
import ErrorAnimationComponent from "../../../assets/lottie/ErrorAnimation/ErrorAnimationComponent";
import InstructorData from "../../../Components/CoursesModuleComponents/InstructorData";
import CourseBasicData from "../../../Components/CoursesModuleComponents/CourseBasicData";
import SocialMediaChannel from "../../../Components/CoursesModuleComponents/SocialMediaChannel";
import ReviewData from "../../../Components/CoursesModuleComponents/ReviewData";
import EyeDetailsIcon from "../../../Components/Svgs/EyeDetailsIcon";
import { getCourseDetails } from "../../../apis";

const CourseDetails = () => {
  const { courseId } = useParams();
  const [courseDetails, setCourseDetails] = useState([]);
  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const basicData = { ...courseDetails?.basicData };
  const courseImage = courseDetails?.basicData?.courseImage;
  basicData.isPartnerDisplayed =
    basicData?.isPartnerDisplayed == 1 ? "Yes" : "No";
  basicData.isSitePublished = basicData?.isPartnerDisplayed == 1 ? "Yes" : "No";

  delete basicData?.id;
  delete basicData?.courseImage;

  const instructorData = courseDetails?.InstructorData;
  const socialMediaData = courseDetails?.socialData;

  useEffect(() => {
    setIsLoading(true);
    getCourseDetails(courseId)
      .then((data) => {
        setCourseDetails(data.data.data);
      })
      .catch((error) => {
        setIsError(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [courseId]);

  if (isLoading) return <Loader />;
  if (isError) return <ErrorAnimationComponent message={isError} />;

  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Courses Management",
            link: `/courses-management`,
          },
          { title: "Course Details" },
        ]}
      />

      <div className="tw-flex max-lg:tw-flex-col max-lg:tw-gap-4 justify-content-between tw-items-center tw-mb-6">
        <h2 className="h4 !tw-m-0">Course Details</h2>
        <div className="tw-flex max-sm:tw-flex-col tw-items-center tw-gap-2">
          <LightButton
            text={"Edit In Course"}
            icon={<span className="material-icons tw-me-2">edit</span>}
            to={`/update-course/${courseId}`}
            hoverColor={"hover:!tw-text-blueLight"}
          />
          <LightButton
            text={"View Course Lessons"}
            icon={<span className="material-icons tw-me-2">visibility</span>}
            to={"lessons-in-course"}
          />
        </div>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-4">
        <CourseBasicData
          title="Basic Data"
          data={transformKeys(basicData || {})}
          img={courseImage}
        />
        <InstructorData title={"Instructor Data"} data={instructorData || {}} />
        <SocialMediaChannel
          title={"Social Media Channel"}
          data={socialMediaData || []}
          setCourseDetails={setCourseDetails}
        />
        <ReviewData title={"Rating & Review Data"} />
      </div>
    </>
  );
};

export default CourseDetails;
